// ABOUTME: Shared "view all" modal for the family strip's approval and celebration queue cards
// ABOUTME: Renders the full unpaginated list, scrollable within the dialog

import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export interface FamilyStripQueueModalRow {
  key: string;
  node: React.ReactNode;
}

export interface FamilyStripQueueModalProps {
  open: boolean;
  title: string;
  rows: FamilyStripQueueModalRow[];
  onClose: () => void;
}

export const FamilyStripQueueModal: React.FC<FamilyStripQueueModalProps> = ({ open, title, rows, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      {title}
      <IconButton aria-label="close" onClick={onClose} size="small">
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {rows.map(row => <React.Fragment key={row.key}>{row.node}</React.Fragment>)}
      </Box>
    </DialogContent>
  </Dialog>
);
